"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Adapted from https://github.com/ProjectMirador/mirador/blob/master/src/lib/MiradorViewer.js

var react_1 = __importStar(require("react"));

var styles_1 = require("@material-ui/core/styles");

var deepmerge_1 = __importDefault(require("deepmerge"));

var MiradorViewer_1 = __importDefault(require("mirador/dist/es/src/lib/MiradorViewer"));

var settings_1 = __importDefault(require("mirador/dist/es/src/config/settings"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./style.scss");
/**
* Mirador Viewer component.
*/


var Mirador = function Mirador(_a) {
  var className = _a.className,
      _b = _a.config,
      config = _b === void 0 ? {} : _b,
      plugins = _a.plugins,
      style = _a.style;

  var _c = (0, react_1.useState)(undefined),
      mirador = _c[0],
      setMirador = _c[1];

  (0, react_1.useEffect)(function () {
    var mergedConfig = (0, deepmerge_1.default)(settings_1.default, config);
    var viewer = new MiradorViewer_1.default(mergedConfig, {
      plugins: plugins
    });
    setMirador(viewer);
  }, [config]);
  var generateClassName = (0, styles_1.createGenerateClassName)({
    productionPrefix: 'p',
    seed: "stories-api-mirador-" + new Date().getTime()
  });
  return react_1.default.createElement(styles_1.StylesProvider, {
    generateClassName: generateClassName
  }, react_1.default.createElement(styles_1.MuiThemeProvider, {
    theme: (0, styles_1.createTheme)()
  }, react_1.default.createElement("div", {
    style: style,
    className: "story-mirador " + className + " mirador--initialized"
  }, (mirador === null || mirador === void 0 ? void 0 : mirador.render()) || null)));
};

Mirador.propTypes = {
  /** Set a classname of the mirador Component */
  className: prop_types_1.default.string,

  /** Configuration options for the viewer */
  // eslint-disable-next-line react/forbid-prop-types
  config: prop_types_1.default.object,

  /** Specify any additional plugins to render */
  plugins: prop_types_1.default.arrayOf(prop_types_1.default.object)
};
Mirador.defaultProps = {
  className: '',
  config: {},
  plugins: [],
  style: undefined
};
exports.default = Mirador;